import React from 'react';
import { getLinksAndMailsFromString } from 'src/common/helpers/get-links-and-mails-from-string';
import { WizardContentSectionTemplate } from './template';
import uniqBy from 'lodash/uniqBy';
import { useNotificationMessage } from 'src/common/notification/message.hook';
import { DashboardLibraryContentAddPanelLinkInput } from './link-input';

interface Props {
  onLinkNotFound: () => void;
  onAddLinks: (links: string[]) => void;
}

export const WizardContentSectionAddLinks = ({ onAddLinks, onLinkNotFound }: Props) => {
  const { setErrorNotification } = useNotificationMessage();
  return (
    <WizardContentSectionTemplate
      title='Add links'
      description='If your content is a URL paste it below. You can even copy and paste an email with links that will be extracted'
    >
      <DashboardLibraryContentAddPanelLinkInput
        processInput={(input) => {
          if (input) {
            const cleanedInput = input.replace(/(data-saferedirecturl)="[^"]*"/g, '');
            // somehow, it extracts emails twice
            const links = getLinksAndMailsFromString(cleanedInput);
            if (links.length === 0) {
              setErrorNotification('No links found');
              onLinkNotFound();
              return;
            }
            onAddLinks(
              uniqBy(
                /**
                 * texts copied from "Notes", put '/' at the end of the URL
                 * which causes duplication issue
                 */
                links.map((link) => (link[link.length - 1] === '/' ? link.substring(0, link.length - 1) : link)),
                (link) => link
              )
            );
          }
        }}
      />
    </WizardContentSectionTemplate>
  );
};
